import React from 'react';
import PropTypes from 'prop-types';
import cs from 'classnames';

import Checkbox from '../../../../components/react-checkbox';
import Radio from '../../../../components/react-radio-button';
import TogglePill from '../../../../components/react-toggle-pill';

import './index.scss';

const LabeledOption = ({
  label = '',
  selected = false,
  onClick,
  className = '',
  typeOfInput = 'Checkbox',
  id,
  icon = null,
  disabled = false,
}) => {
  const ariaLabel = (label && label.props && label.props.defaultMessage) || '';
  const inputMap = {
    Checkbox: <Checkbox checked={selected} id={id} color="$dark-steel" ariaLabel={ariaLabel} />,
    Radio: <Radio checked={selected} id={id} ariaLabel={ariaLabel} />,
    Toggle: <TogglePill checked={selected} id={id} ariaLabel={ariaLabel} />,
  };

  return (
    <div
      className={cs(
        'LabeledOption',
        {
          'LabeledOption--disabled': disabled,
        },
        className
      )}
      onClick={onClick}
    >
      {icon && <div className="LabeledOption__icon">{icon}</div>}
      <label className="LabeledOption__label" htmlFor={id}>
        {label}
      </label>
      {inputMap[typeOfInput]}
    </div>
  );
};

LabeledOption.propTypes = {
  label: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.string]),

  /** Is labeled option selected= */
  selected: PropTypes.bool,
  onClick: PropTypes.func,

  /** Css class name */
  className: PropTypes.string,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  icon: PropTypes.element,

  typeOfInput: PropTypes.string,

  /** Is labeled option disabled? */
  disabled: PropTypes.bool,
};

export default LabeledOption;
